/* Candywrap opnieuw bestellen.
   1) Houdt een kopie van de mand bij (cw-cart-mirror) en bewaart die bij het afrekenen als 'pending' in cw-last-order.
   2) Bij een volgend bezoek: is de mand leeg of nieuw, dan is de bestelling gelukt en wordt cw-last-order 'done'.
   3) Toont 'Vorige keer besteld' (ingelogd: echte laatste bestelling uit Shopify, anders cw-last-order 'done'). */
(function () {
  'use strict';
  if (window.__cwReorder) return;
  window.__cwReorder = true;

  var MIRROR = 'cw-cart-mirror', LAST = 'cw-last-order';
  function get(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function cartJs() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function slim(cart) {
    var items = [];
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._cw_gift || p._mb || p._mix || p._dagaanbieding || it.final_price === 0) return;
      var props = {};
      Object.keys(p).forEach(function (k) { if (k.charAt(0) !== '_' && p[k]) props[k] = p[k]; });
      items.push({ v: it.variant_id, q: it.quantity, h: it.handle, t: it.product_title, vt: it.variant_title || '', img: it.image || '', props: props });
    });
    return { token: cart.token, ts: Date.now(), items: items };
  }
  function mirror() { return cartJs().then(function (c) { set(MIRROR, slim(c)); return c; }).catch(function () {}); }

  /* bij afrekenen: kopie bewaren als 'pending' */
  function markCheckout() {
    var m = get(MIRROR);
    if (m && m.items && m.items.length) { m.state = 'pending'; m.ts = Date.now(); set(LAST, m); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], .cw-btn-order');
    if (t) markCheckout();
  }, true);
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if ((sub && sub.name === 'checkout') || (e.target && e.target.querySelector && e.target.querySelector('[name="checkout"]') && /\/cart/.test(e.target.action || ''))) markCheckout();
  }, true);

  /* mand-kopie bijwerken na elke wijziging */
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) { if (/\/cart\/(add|change|update|clear)/.test(en.name)) setTimeout(mirror, 250); });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  /* pending afronden: lege of nieuwe mand betekent dat de bestelling gelukt is */
  function settle(cart) {
    var last = get(LAST);
    if (last && last.state === 'pending' && cart) {
      if (!cart.item_count || cart.token !== last.token) { last.state = 'done'; set(LAST, last); }
      else if (Date.now() - last.ts > 1000 * 60 * 60 * 24 * 14) { localStorage.removeItem(LAST); }
    }
  }

  /* weergave */
  var ic = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render(root, data) {
    var list = root.querySelector('[data-cwro-list]');
    var items = (data.items || []).slice(0, 12);
    if (!items.length) return;
    var sub = root.querySelector('[data-cwro-sub]');
    if (sub && data.date) sub.textContent = 'Je bestelling van ' + data.date + '. ' + sub.textContent;
    list.innerHTML = items.map(function (it, i) {
      var vt = it.vt && it.vt !== 'Default Title' ? it.vt : '';
      return '<li class="cwro-it" data-i="' + i + '">' +
        '<button type="button" class="cwro-tg" data-cwro-tg aria-label="Meenemen of weglaten">' + ic + '</button>' +
        '<a class="cwro-ti' + (it.cut ? ' is-cut' : '') + '" href="/products/' + esc(it.h) + '">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy" width="200" height="200">' : '') + '</a>' +
        '<b>' + esc(it.t) + '</b>' + (vt ? '<small>' + esc(vt) + '</small>' : '') +
        '<div class="cwro-row"><span class="cwro-q"><button type="button" data-cwro-q="-1" aria-label="Minder">−</button><span data-cwro-n>' + it.q + '</span><button type="button" data-cwro-q="1" aria-label="Meer">+</button></span></div>' +
        '</li>';
    }).join('');
    root.hidden = false;
    root.__items = items;

    /* beschikbaarheid per product, uitverkocht: uitzetten met link naar vergelijkbaar */
    items.forEach(function (it, i) {
      fetch('/products/' + encodeURIComponent(it.h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        var li = list.querySelector('[data-i="' + i + '"]'); if (!li) return;
        var v = p && (p.variants || []).filter(function (x) { return x.id === it.v; })[0];
        if (!p || !v || !v.available) {
          it.off = true; it.sold = true; li.classList.add('is-off');
          var row = li.querySelector('.cwro-row');
          var q = (it.t || '').split(/[:\s]/).filter(Boolean)[0] || '';
          row.innerHTML = '<span class="cwro-sold">Nu op</span><a class="cwro-swap" href="/search?type=product&q=' + encodeURIComponent(q) + '">Vervang</a>';
        }
      }).catch(function () {});
    });

    list.addEventListener('click', function (e) {
      var li = e.target.closest('.cwro-it'); if (!li) return;
      var it = items[+li.getAttribute('data-i')]; if (!it || it.sold) return;
      if (e.target.closest('[data-cwro-tg]')) { it.off = !it.off; li.classList.toggle('is-off', it.off); }
      var qb = e.target.closest('[data-cwro-q]');
      if (qb) { it.q = Math.max(1, Math.min(20, it.q + parseInt(qb.getAttribute('data-cwro-q'), 10))); li.querySelector('[data-cwro-n]').textContent = it.q; }
    });

    var btn = root.querySelector('[data-cwro-all]');
    btn.addEventListener('click', function () {
      var add = items.filter(function (it) { return !it.off && !it.sold; }).map(function (it) {
        var o = { id: it.v, quantity: it.q }; if (it.props && Object.keys(it.props).length) o.properties = it.props; return o;
      });
      if (!add.length) return;
      if (window.cwHome && window.cwHome.add) { window.cwHome.add(add, btn); return; }
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: add }) })
        .then(function () {
          btn.disabled = false;
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }).catch(function () { btn.disabled = false; });
    });
  }

  function boot() {
    mirror().then(function (cart) {
      settle(cart);
      var root = document.querySelector('[data-cw-reorder]'); if (!root || root.__done) return;
      root.__done = true;
      var src = document.querySelector('[data-cwro-src]'), data = null;
      if (src) { try { data = JSON.parse(src.textContent); } catch (e) {} }
      if (!data || !data.items || !data.items.length) {
        var last = get(LAST);
        if (last && last.state === 'done' && last.items && last.items.length) {
          data = { src: 'browser', date: new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long' }).format(new Date(last.ts)), items: last.items.map(function (x) { return { v: x.v, q: x.q, h: x.h, t: x.t, vt: x.vt, img: x.img, props: x.props }; }) };
        }
      }
      if (data) render(root, data);
    });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
